import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// a very naive version of react-intl's FormattedMessage
function FormattedMessage({ defaultMessage, values }) {
  const messages = defaultMessage.split(/({.*?})/);

  return messages.map((message, index) => {
    if (message.startsWith('{') && message.endsWith('}')) {
      // eslint-disable-next-line react/no-array-index-key
      return <Fragment key={index}>{values[message.slice(1, -1)]}</Fragment>;
    }

    // eslint-disable-next-line react/no-array-index-key
    return <Fragment key={index}>{message}</Fragment>;
  });
}

FormattedMessage.propTypes = {
  defaultMessage: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired
};

export default FormattedMessage;
